/**
 * Department create/patch refusals the backend names with a code — body
 * `{ code, error }` (403 Master-only / self-grant, 409 head changed meanwhile,
 * 400 invalid head for data access). Maps the code to an i18n key; anything
 * else stays the generic "error".
 */
const DEPARTMENT_ERROR_KEYS: Record<string, string> = {
  HEAD_DATA_ACCESS_MASTER_ONLY: "department_head_data_access_master_only",
  FLAGGED_DEPARTMENT_MASTER_ONLY: "department_error_flagged_master_only",
  HEAD_DATA_ACCESS_SELF_GRANT: "department_error_head_data_access_self_grant",
  DEPARTMENT_HEAD_CHANGED: "department_error_head_changed",
  HEAD_DATA_ACCESS_INVALID_HEAD: "department_error_head_data_access_invalid_head",
};

export function departmentErrorKey(error: any): string {
  const data = error?.response?.data;
  const candidates =
    typeof data === "string" ? [data] : [data?.code, data?.error, data?.errorCode, data?.message];
  const code = candidates.find((value) => typeof value === "string" && DEPARTMENT_ERROR_KEYS[value]);
  return code ? DEPARTMENT_ERROR_KEYS[code] : "error";
}

/**
 * Refusals of an onboarding's departments (the record's tags on create/edit,
 * the employee's memberships at activation): a hiring head must pick at
 * least one, and only among the departments he heads. Body `{ error }`.
 */
const ONBOARDING_DEPARTMENT_ERROR_KEYS: Record<string, string> = {
  DEPARTMENT_REQUIRED: "onboarding_department_required",
  DEPARTMENT_NOT_IN_SCOPE: "onboarding_department_not_in_scope",
};

/** The i18n key for such a refusal, or null when the error is something else. */
export function onboardingDepartmentErrorKey(error: any): string | null {
  const code = error?.response?.data?.error;
  return (typeof code === "string" && ONBOARDING_DEPARTMENT_ERROR_KEYS[code]) || null;
}
